import { Column } from './types';

/**
 * 二段組ヘッダーの入れ子カラムを展開し、行データの並びと 1:1 対応する
 * フラットなカラム配列を返す
 */
export const columnsExtension = (columns: Column[]): Column[] =>
  columns.flatMap((column) =>
    column.columns != null && column.columns.length > 0
      ? (column.columns as Column[])
      : [column]
  );
